import { DataTableCol } from "../../../components/tables/types";

export const PercentageDataGridCols: DataTableCol[] = [
    {
        title: 'Date',
        control: 'createdAt',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Batch Name',
        control: 'userBatchName',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Percentage',
        control: 'percentage',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: true,
        isDelete: true,
        canShowColumn: true
    },
];